import { render, staticRenderFns } from "./PosOrderModal.vue?vue&type=template&id=b4968824"
import script from "./PosOrderModal.vue?vue&type=script&lang=ts"
export * from "./PosOrderModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports